import {Component, inject, Input} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';

@Component({
  selector: 'app-unsaved-data',
  imports: [MatDialogModule, MatButtonModule],
  styleUrl: './unsaved-data.component.scss',
  template: `<h1 mat-dialog-title>Unsaved changes</h1>
    <mat-dialog-content>
      You have made changes to this {{ macguffin }}, but haven't yet saved them.<br />
      Are you sure you want to leave this page?
    </mat-dialog-content>
    <mat-dialog-actions>
      <button matButton="filled" [mat-dialog-close]="false" class="btn-cancel">Stay</button>
      <button matButton="filled" [mat-dialog-close]="true" class="btn-danger">Continue</button>
    </mat-dialog-actions>`,
})
export class UnsavedDataComponent {
  @Input()
  public macguffin = 'object';

  constructor() {
    const data = inject(MAT_DIALOG_DATA, {optional: true});
    this.macguffin = data?.macguffin ?? 'object';
  }
}
